export default __webpack_public_path__ + "static/media/trend.849bf8fa.png";